import type { PropsWithChildren } from 'react';

import { cn } from '~/lib/cn';
import { variants } from '~/lib/variants';

type Columns = 1 | 2 | 3 | 4 | 5 | 6;

interface GridLayoutProps extends PropsWithChildren {
  columns?: Columns;
  fixed?: boolean;
}

const grid = variants({
  base: ['grid', 'gap-md'],
  variants: {
    columns: {
      1: ['grid-cols-1'],
      2: ['grid-cols-2'],
      3: ['grid-cols-3'],
      4: ['grid-cols-4'],
      5: ['grid-cols-5'],
      6: ['grid-cols-6'],
    },
    fixed: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      fixed: false,
      columns: 2,
      class: ['grid-cols-1 @sm:grid-cols-2'],
    },
    {
      fixed: false,
      columns: 3,
      class: ['grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3'],
    },
    {
      fixed: false,
      columns: 4,
      class: ['grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3 @lg:grid-cols-4'],
    },
    {
      fixed: false,
      columns: 5,
      class: [
        'grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3 @lg:grid-cols-4 @xl:grid-cols-5',
      ],
    },
    {
      fixed: false,
      columns: 6,
      class: [
        'grid-cols-1 @sm:grid-cols-2 @md:grid-cols-3 @lg:grid-cols-4 @xl:grid-cols-5 @2xl:grid-cols-6',
      ],
    },
  ],
});

export function ColumnLayout({
  children,
  columns = 3,
  fixed = false,
  ...props
}: GridLayoutProps) {
  return (
    <div {...props} className={cn(grid({ columns, fixed }))}>
      {children}
    </div>
  );
}

ColumnLayout.displayName = 'ColumnLayout';
